import { FieldConfig } from '../ModalFieldRenderer';
import { TherapeuticArea } from '../../../services/api/domains/therapeutic-areas/types';
import { validationHelpers } from '../utils/validation';
import { formatDateTime } from 'utils/dateConversion';

// Therapeutic Area ID field (always disabled, only shown when editing existing)
export const therapeuticAreaIdField: FieldConfig<TherapeuticArea> = {
  key: 'therapeutic_area_id',
  label: 'Therapeutic Area ID',
  type: 'readonly',
  getValue: ta => ta.therapeutic_area_id?.toString() || '',
  isAlwaysDisabled: true,
};

// Fields that are always disabled (audit fields)
export const therapeuticAreaAlwaysDisabledFields = [
  'therapeutic_area_id',
  'created_date',
  'modified_date',
  'user_id',
];

// Main therapeutic area fields configuration
export const therapeuticAreaFields: FieldConfig<TherapeuticArea>[] = [
  // Name field
  {
    key: 'therapeutic_area_name',
    label: 'Therapeutic Area Name',
    type: 'text',
    getValue: ta => ta.therapeutic_area_name || '',
    setValue: (ta, val) => ({ ...ta, therapeutic_area_name: val }),
    isRequired: true,
    validator: validationHelpers.combine(
      validationHelpers.required,
      validationHelpers.minLength(2)
    ),
  },

  // Audit fields (always disabled)
  {
    key: 'created_date',
    label: 'Created',
    type: 'readonly',
    getValue: ta => ta.created_date || '',
    formatter: formatDateTime,
    isAlwaysDisabled: true,
  },

  {
    key: 'modified_date',
    label: 'Last Updated',
    type: 'readonly',
    getValue: ta => ta.modified_date || '',
    formatter: formatDateTime,
    isAlwaysDisabled: true,
  },

  {
    key: 'user_id',
    label: 'User ID',
    type: 'readonly',
    getValue: ta => ta.user_id || '',
    isAlwaysDisabled: true,
  },
];
